import { Crypto } from "./crypto";

export enum ReadReason {
  LOW_LIQUIDITY = "LOW_LIQUIDITY",
  INCOMPATIBLE_CHAIN = "INCOMPATIBLE_CHAIN",
  DIFFERENT_COIN = "DIFFERENT_COIN",
  OTHER = "OTHER",
}

export interface MarkAsReadCrypto {
  id: string;
  name: string;
  quoteCoin?: string;
  exchange: string;
  crypto: Crypto;
  endDate: string;
  reason: ReadReason;
  volumeToRemoveMarkAsRead?: number;
}
